import React from 'react';
import classNames from 'classnames';

import css from './IconArrowLeft.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconArrowLeft = props => {
  const { className, rootClassName, proposal } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M18 10.125H7.35125L12.2425 5.23375L11 4L4 11L11 18L12.2337 16.7663L7.35125 11.875H18V10.125Z" fill="#1E2022" />
    </svg>
  );
};

export default IconArrowLeft;
